import { api } from "@/lib/api";
import {
  mapDtoToService,
  mapServiceToDto,
  Service,
  serviceDtoSchema,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getServiceQueryOptions, getServicesQueryOptions } from "./get.hooks";

export function useUpdateService(opts?: {
  onSuccess?: (service: Service) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (service: Service) => {
      const dto = mapServiceToDto(service);
      const result = await api.put("/api/services", dto, serviceDtoSchema);
      return mapDtoToService(result);
    },
    onSuccess: (service) => {
      queryClient.setQueryData(getServicesQueryOptions.queryKey, (old) =>
        old?.map((s) => (s.id === service.id ? service : s)),
      );
      queryClient.setQueryData(
        getServiceQueryOptions(service.id.toString()).queryKey,
        () => service,
      );
      toast({
        title: "toast.serviceUpdated",
        variant: "success",
      });
      opts?.onSuccess?.(service);
    },
    onError: () => {
      toast({
        title: "toast.updateServiceError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
